import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import {
  FDIcon, FDStack,
} from '@facet-wealth/design';

function MultipicklistNewGroupHeader({
  description,
  groupName,
  icon,
}) {
  if (description) {
    return (
      <FDStack direction={'column'} spacing={2}>
        <Typography variant="h4" weight="extraBold" color={'primary'}>
          {groupName}
        </Typography>
        <Typography variant="h5" weight="medium" color={'primaryGray'}>
          {description}
        </Typography>
      </FDStack>
    );
  }

  return (
    <FDStack direction={'column'} spacing={1}>
      <FDStack direction={'row'} justifyContent={'space-between'} padding={2}>
        <Typography variant="h4" weight="extraBold" color={'primary'}>
          {groupName}
        </Typography>
        {icon ? <FDIcon icon={icon} color={'secondary'} /> : null}
      </FDStack>
    </FDStack>
  );
}

MultipicklistNewGroupHeader.defaultProps = {
  description: '',
  icon: undefined,
};

MultipicklistNewGroupHeader.propTypes = {
  description: PropTypes.string,
  groupName: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

export default MultipicklistNewGroupHeader;
